import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiHeader from "../../components/MuiHeader";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AodIcon from "@mui/icons-material/Aod";
import CategoryIcon from "@mui/icons-material/Category";
import TextField from "@mui/material/TextField";
import Modal from "@mui/material/Modal";
import api from "../../api/api";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import "./EraseUserdata.css";

import { red, blue, green, purple } from "@mui/material/colors";
// MUI
import {
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import SearchIcon from "@mui/icons-material/Search";
import MuiLoader from "../../components/MuiLoader";

//--------------Functionality Thunks--------------------
import { getAllUsersByNames } from "./EraseUserdata.thunk";
import ClearUserdata from "../../components/ClearUserdata";

//---------------------------------------------------------

const EraseUserdata = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [searchedUser, setSearchedUser] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const getTheUsers = () => {
    setIsLoading(true);
    const data = {
      searchString: searchedUser,
    };
    getAllUsersByNames(data)
      .then((res) => {
        const filteredUsers = Array.isArray(res?.data)
          ? res.data.filter(Boolean)
          : [];
        setAllUsers(filteredUsers);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("The error is--------------->", error);
        if (error.response.status === 500) {
          toast.error("Internal server error.");
        } else if (error.response.status === 504) {
          toast.error("Server timeout. Please try again later.");
        } else {
          console.error("An unexpected error occurred:", error);
          toast.error("An unexpected error occurred. Please try again later.");
        }
      });
  };

  const handleUserSelection = (event, newValue) => {
    setSelectedUser(newValue);
    setAllUsers([]);
    setInputValue("");
  };

  //console.log("selectedUser-------->", selectedUser);
  //console.log("userid sent-------->", selectedUser?.userid);

  return (
    <>
      <MuiHeader header="Erase Userdata" />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginLeft: "20px",
          width: "74.5%",
          marginTop: "80px",
          flexWrap: "wrap",
        }}
      >
        <div className="searchbar">
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            value={selectedUser}
            inputValue={inputValue}
            onChange={handleUserSelection}
            onInputChange={(event, newInputValue) => {
              newInputValue = newInputValue.trimStart();
              setInputValue(newInputValue);
              setSearchedUser(newInputValue);
              if (newInputValue === "") {
                setAllUsers([]);
              } else if (newInputValue.length >= 4) {
                getTheUsers();
              } else {
                setAllUsers([]);
                if (newInputValue.length > 0) {
                  toast.warn("At least add 4 characters!");
                }
              }
            }}
            options={allUsers}
            getOptionLabel={(option) =>
              option["username"] + option["userid"] || ""
            }
            renderInput={(params) => (
              <TextField {...params} label="Search Users" />
            )}
          />
        </div>
      </div>
      <div style={{ marginLeft: "-35px" }}>
        {selectedUser?.userid ? (
          <ClearUserdata id={selectedUser?.userid} />
        ) : null}
      </div>
      <ToastContainer />
    </>
  );
};

export default EraseUserdata;
